<template>
  <div class="product-card-price-component">
    <span class="price alt:!items-start alt:mb-2">
      <span class="flex flex-col alt:flex-col-reverse">
        <span v-if="isDiscount" class="old-price">
          {{ toPrice(oldPrice) }}
        </span>
        <span v-else class="old-price-spacer">&nbsp;</span>
        <span class="current-price">
          {{ toPrice(currentPrice) }}
        </span>
      </span>
      <span class="converted-price">({{ toPriceConverted(currentPrice) }})</span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import toPrice from '@/utils/toPrice'
import toPriceConverted from '@/utils/toPriceConverted'

const props = defineProps<{
  oldPrice?: number | null
  currentPrice: number | null
}>()

const isDiscount = computed<boolean>(() => Boolean(props.oldPrice && props.oldPrice > (props.currentPrice ?? 0)))
</script>

<style lang="postcss" scoped>
.product-card-price-component {
  @apply flex w-full;

  .price {
    @apply flex flex-row justify-start items-end flex-wrap gap-1 py-4 alt:pb-0;

    .old-price {
      @apply text-text2 dark:text-dmText2 lg:text-lg line-through;
    }

    .old-price + .current-price {
      @apply text-brand-primary;
    }

    .old-price-spacer {
      @apply flex text-text2 dark:text-dmText2 lg:text-lg;
    }

    .current-price {
      @apply text-lg lg:text-2xl font-bold leading-none;
    }

    .converted-price {
      @apply text-sm lg:text-lg text-black dark:text-white leading-[1rem] lg:leading-[1.5rem];
    }
  }
}
</style>
